import { TourAndGallerySettings } from 'src/services/src/service/tour-and-gallery/types';

export enum TourAndGalleryActionTypes {
  GetSettingsRequest = 'TourAndGallery/GetSettingsRequest',
  GetSettingsSuccess = 'TourAndGallery/GetSettingsSuccess',
  GetSettingsError = 'TourAndGallery/GetSettingsError',
  UpdateSettingsRequest = 'TourAndGallery/UpdateSettingsRequest',
  UpdateSettingsSuccess = 'TourAndGallery/UpdateSettingsSuccess',
  UpdateSettingsError = 'TourAndGallery/UpdateSettingsError',
  NotifyIsDirty = 'TourAndGallery/NotifyIsDirty',
  GetCatalogPreviewError = 'TourAndGallery/GetCatalogPreviewError',
}

export interface GetSettingsArgs {
  shopId: number;
}

export interface UpdateSettingsArgs {
  shopId: number;
  settings: TourAndGallerySettings;
}

export interface GetSettingsRequestPayload {
  shopId: number;
}

export interface GetSettingsSuccessPayload {
  shopId: number;
  settings: TourAndGallerySettings;
}

export interface GetSettingsErrorPayload {
  error: unknown;
}

export interface UpdateSettingsRequestPayload {
  shopId: number;
  settings: TourAndGallerySettings;
}

export interface UpdateSettingsSuccessPayload {
  shopId: number;
  settings: TourAndGallerySettings;
}

export interface UpdateSettingsErrorPayload {
  error: unknown;
  customMessage?: string;
}

export interface GetCatalogPreviewErrorPayload {
  error: unknown;
}

export interface NotifyIsDirtyPayload {
  isDirty: boolean;
}

export interface GetSettingsRequestAction {
  type: typeof TourAndGalleryActionTypes.GetSettingsRequest;
  payload: GetSettingsRequestPayload;
}

export interface GetSettingsSuccessAction {
  type: typeof TourAndGalleryActionTypes.GetSettingsSuccess;
  payload: GetSettingsSuccessPayload;
}

export interface GetSettingsErrorAction {
  type: typeof TourAndGalleryActionTypes.GetSettingsError;
  payload: GetSettingsErrorPayload;
}

export interface UpdateSettingsRequestAction {
  type: typeof TourAndGalleryActionTypes.UpdateSettingsRequest;
  payload: UpdateSettingsRequestPayload;
}

export interface UpdateSettingsSuccessAction {
  type: typeof TourAndGalleryActionTypes.UpdateSettingsSuccess;
  payload: UpdateSettingsSuccessPayload;
}

export interface UpdateSettingsErrorAction {
  type: typeof TourAndGalleryActionTypes.UpdateSettingsError;
  payload: UpdateSettingsErrorPayload;
}

export interface GetCatalogPreviewErrorAction {
  type: typeof TourAndGalleryActionTypes.GetCatalogPreviewError;
  payload: GetCatalogPreviewErrorPayload;
}

export interface NotifyIsDirtyAction {
  type: typeof TourAndGalleryActionTypes.NotifyIsDirty;
  payload: NotifyIsDirtyPayload;
}

export type TourAndGalleryAction =
  | GetSettingsRequestAction
  | GetSettingsSuccessAction
  | GetSettingsErrorAction
  | UpdateSettingsRequestAction
  | UpdateSettingsSuccessAction
  | UpdateSettingsErrorAction
  | NotifyIsDirtyAction
  | GetCatalogPreviewErrorAction;
